/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum IWalletCategory {
  Investor = 'investor',
  Project = 'project',
  Platform = 'platform',
}

export enum IProjectCreditorPosition {
  Junior = 'junior',
  Senior = 'senior',
  Combined = 'combined',
  Custom = 'custom',
}

export enum IProjectCollateralSubcategory {
  Flat = 'flat',
  House = 'house',
  Apartman = 'apartman',
  Office = 'office',
  CommercialSpace = 'commercialSpace',
  Polyfunction = 'polyfunction',
  BuildingLands = 'buildingLands',
  Meadow = 'meadow',
  Garden = 'garden',
  OtherLand = 'otherLand',
  Hotel = 'hotel',
  Pension = 'pension',
  Cottage = 'cottage',
  Accommodation = 'accommodation',
  GasStation = 'gasStation',
  Logistics = 'logistics',
  ManufacturingArea = 'manufacturingArea',
  Warehouse = 'warehouse',
  Garage = 'garage',
  RealEstate = 'realEstate',
  Other = 'other',
}

export enum IProjectCollateralCategory {
  Residential = 'residential',
  Commercial = 'commercial',
  Land = 'land',
  Recreational = 'recreational',
  Other = 'other',
}

export enum IProjectCollateralType {
  Property = 'property',
}

export enum IProjectLoanType {
  AssetBasedLoan = 'assetBasedLoan',
}

export enum IWalletType {
  CSOB = 'CSOB',
}

export enum IProjectPropertyRentalContracts {
  WithRentalContracts = 'withRentalContracts',
  WithoutRentalContracts = 'withoutRentalContracts',
}

export enum IProjectPropertyEncumbrance {
  WithEncumbrance = 'withEncumbrance',
  WithEncumbrances = 'withEncumbrances',
  WithoutEncumbrance = 'withoutEncumbrance',
}

export enum IProjectCountry {
  SK = 'SK',
  CZ = 'CZ',
}

export enum IYieldCompounding {
  None = 'none',
  Annually = 'annually',
}

export enum IProjectPaymentType {
  WYtH2FcWv8FvnywF9 = 'wYtH2fcWv8fvnywF9',
  NmMQDPs7FbinwaHJo = 'NmMQDPs7fbinwaHJo',
  GqBX9Z6CB9DKdrpY2 = 'GqBX9Z6cB9DKdrpY2',
  IKJoNu4ImSMTZ596D = 'iKJoNu4imSMTZ596D',
  DW52PBdeLbgMmJXci = 'dW52PBdeLbgMmJXci',
  G9GP3ZhJ9P6NRJkRh = 'g9GP3ZhJ9p6nRJkRh',
}

export enum IProjectLoanPurpose {
  Reconstruction = 'reconstruction',
  Construction = 'construction',
  Investment = 'investment',
  Buying = 'buying',
  Business = 'business',
  Purchase = 'purchase',
  Refinancing = 'refinancing',
  Development = 'development',
  Flipping = 'flipping',
}

export enum ICurrency {
  Eur = 'eur',
  Czk = 'czk',
}

export enum IProjectStatus {
  Created = 'created',
  Preparing = 'preparing',
  Running = 'running',
  CampaignFinished = 'campaignFinished',
  Funded = 'funded',
  Finished = 'finished',
  Cancelled = 'cancelled',
}

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface IListFilteredProjectsRequest {
  /** Max počet položiek; 0 alebo vynechané = bez limitu (1:1 Meteor `limit ?? 0`, Mongo limit 0 = unlimited) */
  limit?: number
  /** @default 0 */
  offset?: number
  orderBy?: 'businessId' | 'publishedDate' | 'yieldPerAnnum'
  orderDir?: 'asc' | 'desc'
  statuses?: (
    | 'created'
    | 'preparing'
    | 'running'
    | 'campaignFinished'
    | 'funded'
    | 'finished'
    | 'cancelled'
  )[]
}

export interface IProjectExtraYieldSettingsLegacy {
  maxAmount: number
  maxAmountFixed: number
  maxPercentage: number
}

export interface IPropertyInfo {
  type: string
  cadastralArea: string
  owners: string
  encumbrance: IProjectPropertyEncumbrance
  rentalContracts: IProjectPropertyRentalContracts
  otherLiabilities: string
  marketValue: number
  expertValueEstimate: number
  mapCoordinates: string
  hasInfoText: boolean
  infoText: string
}

export interface IProjectListItemCollateral {
  collateralCategory: string
  collateralSubcategory: string
  propertyInfo: IPropertyInfo
  ltlPercentageCustom: string | null
}

export interface IProjectListItemHotBonus {
  yieldPerAnnum: number
  /** @format date-time */
  activeFrom: string | null
  /** @format date-time */
  activeTo: string | null
}

export interface ITransactionSchemeSchema {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  title: string
  projectId: string
  groupId: string
  fixedYield: number
  bonusPrereservation: number
  /** @format date-time */
  bonusPrereservationStart?: string
  /** @format date-time */
  bonusPrereservationEnd?: string
  bonusLastminute: number
  /** @format date-time */
  bonusLastminuteStart?: string
  /** @format date-time */
  bonusLastminuteEnd?: string
  bonusFixed: number
  description: string
}

export interface IAppFileImageSize {
  width: number
  height: number
  path: string
  orientation?: 'landscape' | 'portrait'
}

export interface IProjectListItemImage {
  _id: string
  typeId: 'image' | 'collateralImage' | 'attachment'
  path: string
  name: string
  sizes: IAppFileImageSize[]
  contentType: string
  projectId: string
}

export interface IProjectListItemCalculatedValues {
  minYieldValue: number
  maxYieldValue: number
}

export interface IProjectListItem {
  _id: string
  businessId: number
  stageNumber: number
  statusId: IProjectStatus
  recommended: boolean
  creditLine: number
  currencyId: ICurrency
  investmentPeriod: number
  investmentFutureRevenueEnabled: boolean
  loanPurpose: IProjectLoanPurpose | null
  paymentTypeId: IProjectPaymentType
  riskScore: number | null
  amountCurrent: number
  amountTarget: number
  location: string | null
  blurTags: string[]
  blurTagNames: string[]
  yieldCompounding?: IYieldCompounding
  extraYieldSettings: IProjectExtraYieldSettingsLegacy
  country: IProjectCountry
  ltlPercentage: number | null
  totalAmountToBePaid: number
  totalPaidAmount: number
  projectTargetAmount: number
  stageTargetAmount: number
  collateralInfo: IProjectListItemCollateral
  yield: number
  hotBonus: IProjectListItemHotBonus
  scheme: ITransactionSchemeSchema
  /** @format date-time */
  payoutDate: string | null
  images: IProjectListItemImage[]
  availableFutureRevenueFixed: number
  yieldPerAnnum: number
  maxExtraYieldPerAnnum: number | null
  _calculatedValues: IProjectListItemCalculatedValues
}

export interface IListFilteredProjectsOkResponse {
  /** Optional success message */
  message?: string
  items: IProjectListItem[]
  /** Počet projektov v DB pred scheme filtrom. items.length môže byť menší — projekty bez payout schémy sú zo zoznamu vyradené. */
  totalCount: number
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface IProjectAttachmentPdfDownloadRequest {
  /** Project `_id` */
  projectId: string
  /** AppFile `_id` */
  fileId: string
  /** AppFile `name` — súčasť secure selektora (1:1 Meteor) */
  filename: string
  /** AppFile `token` — súčasť secure selektora (1:1 Meteor) */
  token: string
}

export interface IProjectAttachmentPdfDownloadData {
  /** PDF obsah zakódovaný v base64 */
  file: string
  filename: string
  contentType: string
}

export interface IProjectAttachmentPdfDownloadOkResponse {
  /** Optional success message */
  message?: string
  data: IProjectAttachmentPdfDownloadData
}

export interface INotFoundResponse {
  /** @example 404 */
  statusCode: number
  /** @example "Not Found" */
  error: string
}

export interface IPaymentDateLegacy {
  _id: string
  typeId: string
  /** @format date-time */
  date: string
  planPayments: number
  realPayments: number
  realProgress: number
}

export interface IPaymentStatsLegacy {
  bonus: number
  bonusPaid: number
  bonusProgress: number
  bonusFixed: number
  bonusFixedPaid: number
  bonusFixedProgress: number
  revenue: number
  revenuePaid: number
  revenueProgress: number
  revenue2: number
  revenue2Paid: number
  revenue2Progress: number
  principal: number
  principalPaid: number
  principalProgress: number
  total: number
  totalPaid: number
  totalProgress: number
}

export interface IProjectCollateralInfo {
  collateralType: IProjectCollateralType
  collateralCategory: IProjectCollateralCategory
  collateralSubcategory: IProjectCollateralSubcategory
  otherCollaterals: string
  ltlPercentage: number
  ltlPercentageCustom?: string | null
  creditorPosition: IProjectCreditorPosition
  creditorPositionCustom: IProjectCreditorPosition
  latePaymentFeePercentage: number
  collateralAgent: string
  coInvestment: boolean
  propertyInfo: IPropertyInfo
}

export interface IUserProfileCompanySchema {
  id: string
  vat: string
  vatNumber: string
  name: string
  address?: string
  street?: string
  city: string
  country: string
  zipCode: string
  streetAddress: string
  isSoleTrader: boolean
  registrationInfo: string
  legalForm: string
  state: string
}

export interface IUserProfileDeveloperInfoSchema {
  iisScore: number | null
  latePaymentsCount: number
}

export interface IProjectDetailItemDeveloperProfile {
  company?: IUserProfileCompanySchema
  developerInfo?: IUserProfileDeveloperInfoSchema
}

export interface IProjectDetailItemDeveloper {
  _id: string
  profile: IProjectDetailItemDeveloperProfile
}

export interface IWalletFunds {
  available: number
  blockedInvestment: number
  blockedWithdrawal: number
  blockedPayout: number
  blockedFutureRevenue: number
  gifts: number
}

export interface IWalletAggregates {
  disponibleFunds: number
  expectedFutureRevenue: number
  remainingInvestedFunds: number
  totalBlockedFunds: number
  totalAccountValue: number
}

export interface IWalletStatistics {
  credit: number
  creditCount: number
  creditAvg: number
  /** @format date-time */
  lastCreditAt?: string
  lastCreditAmount: number
  gift: number
  giftCount: number
  reservation: number
  reservationCount: number
  reservationAvg: number
  /** @format date-time */
  lastReservationAt?: string
  lastReservationAmount: number
  investment: number
  investmentCount: number
  investmentAvg: number
  bonus: number
  bonusAffiliate: number
  payout: number
  withdrawal: number
  loansTotalAmount: number
  loansTotalRemainingPayments: number
  loansTotalPaid: number
}

export interface IWalletCSOB {
  variableSymbol: string
}

export interface IWalletSchema {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  userId: string
  category: IWalletCategory
  type: IWalletType
  currencyId: ICurrency
  funds: IWalletFunds
  aggregates: IWalletAggregates
  statistics: IWalletStatistics
  csob: IWalletCSOB
}

export interface IProjectAttachmentItem {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  userId: string
  sign: string
  typeId: string
  investmentId?: string
  projectId?: string
  contentType: string
  extension: string
  filename: string
  name: string
  title?: string
  path: string
  token: string
  ip?: string
  size: number
  sizes: IAppFileImageSize[]
  replacements?: object
  html?: string
  agreementId?: string
  investmentSign?: string
  signatureHashInvestor?: string | null
  signatureQRInvestor?: string | null
  signatureHashDeveloper?: string | null
  signatureQRDeveloper?: string | null
}

export interface IProjectDetailItem {
  _id: string
  /** @format date-time */
  createdAt: string
  createdBy: string
  /** @format date-time */
  modifiedAt: string
  modifiedBy: string
  stageNumber: number
  businessId: number
  developerId: string
  agreementId?: string
  mainInvestorId?: string
  walletId: string
  walletType: IWalletType
  published: boolean
  recommended: boolean
  statusId: IProjectStatus
  sign: string
  paymentType: IProjectPaymentType
  creditLine: number
  projectCurrentAmountFixed: number
  projectTargetAmountFixed: number
  amountCurrent: number
  amountMax: number
  amountMaxFixed: number
  amountMin: number
  amountMinFixed: number
  amountTarget: number
  amountTargetMin: number
  stageCurrentAmountFixed: number
  stageTargetAmountFixed: number
  sumAllStagesAmount: number
  extraYieldSettings: IProjectExtraYieldSettingsLegacy
  stageInvestorCount: number
  projectInvestorCount: number
  sumAllStagesInvestors: number
  investmentPeriod: number
  investmentExtendPeriod: number
  investmentPrincipalMax: number
  investmentPrincipalMaxFixed: number
  investmentFutureRevenueEnabled: boolean
  paymentDatesFixed: IPaymentDateLegacy[]
  paymentStatsFixed: IPaymentStatsLegacy
  paymentDates: IPaymentDateLegacy[]
  paymentStats: IPaymentStatsLegacy
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
  /** @format date-time */
  startInvestmentDate: string | null
  /** @format date-time */
  revenuesFlowStartDate: string
  /** @format date-time */
  stagePublishedAt: string | null
  /** @format date-time */
  projectPublishedAt: string | null
  /** @format date-time */
  statusCampaignFinishedAt: string | null
  /** @format date-time */
  statusCancelledAt: string | null
  /** @format date-time */
  statusFinishedAt: string | null
  /** @format date-time */
  statusFundedAt: string | null
  /** @format date-time */
  statusPreparingAt: string | null
  /** @format date-time */
  statusRunningAt: string | null
  blurTags: string[]
  version: 'v1' | 'v2'
  currencyId: ICurrency
  country: IProjectCountry
  yieldCompounding?: IYieldCompounding
  title: string
  location: string | null
  riskScore: number | null
  expertReview: string
  loanPurpose: IProjectLoanPurpose | null
  loanType: IProjectLoanType | null
  collateralInfo: IProjectCollateralInfo
  timerShowTimeToEnd: boolean
  investors: number
  investorsPlus: number
  progress: number
  progressPlus: number
  likes: number
  likePlus: number
  categoryId: string
  typeId: string
  slug: string
  shortDescription: string
  longDescription: string
  paymentTypeId: IProjectPaymentType
  scheme: ITransactionSchemeSchema
  hotBonus: IProjectListItemHotBonus
  yield: number
  yieldPerAnnum: number
  maxExtraYieldPerAnnum: number | null
  _calculatedValues: IProjectListItemCalculatedValues
  blurTagNames: string[]
  /** @format date-time */
  payoutDate: string | null
  availableFutureRevenueFixed: number
  ltlPercentage: number | null
  totalAmountToBePaid: number
  totalPaidAmount: number
  projectTargetAmount: number
  stageTargetAmount: number
  developer: IProjectDetailItemDeveloper
  wallet: IWalletSchema
  images: IProjectListItemImage[]
  attachments: IProjectAttachmentItem[]
  collateralImage: IProjectListItemImage | null
  _hasUserAccessToProject: boolean
}

export interface IGetProjectDetailOkResponse {
  /** Optional success message */
  message?: string
  project: IProjectDetailItem
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS Project API
 * @version 1.0
 * @contact
 *
 * API for Projects
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  project = {
    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerGetProjects
     * @summary List published projects with optional filter + sort (1:1 Meteor POST user/projects)
     * @request POST:/project
     * @secure
     */
    projectControllerGetProjects: (
      data: IListFilteredProjectsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IListFilteredProjectsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/project`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerDownloadAttachmentPdf
     * @summary Securely download a project attachment PDF as base64 (1:1 Meteor fetchProjectAttachmentAppFile selector)
     * @request POST:/project/app-files/pdf/download
     * @secure
     */
    projectControllerDownloadAttachmentPdf: (
      data: IProjectAttachmentPdfDownloadRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IProjectAttachmentPdfDownloadOkResponse,
        | IBadRequestResponse
        | IUnauthorizedResponse
        | IForbiddenResponse
        | INotFoundResponse
      >({
        path: `/project/app-files/pdf/download`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerGetProjectDetail
     * @summary Project detail by businessId + stageNumber (raw document + joins, 1:1 Meteor)
     * @request GET:/project/{businessId}/{stageNumber}
     * @secure
     */
    projectControllerGetProjectDetail: (
      businessId: number,
      stageNumber: number,
      params: RequestParams = {}
    ) =>
      this.request<
        IGetProjectDetailOkResponse,
        IUnauthorizedResponse | IForbiddenResponse | INotFoundResponse
      >({
        path: `/project/${businessId}/${stageNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerDownloadProjectMedium
     * @request GET:/project/media/{projectId}/{sizedPath}
     * @secure
     */
    projectControllerDownloadProjectMedium: (
      projectId: string,
      sizedPath: string,
      params: RequestParams = {}
    ) =>
      this.request<
        File,
        IUnauthorizedResponse | IForbiddenResponse | INotFoundResponse
      >({
        path: `/project/media/${projectId}/${sizedPath}`,
        method: 'GET',
        secure: true,
        format: 'blob',
        ...params,
      }),
  }
}
